import './vendor';
import './helpers';
import './router';
import './social';
import './video';

// setTimeout(() => {
//   console.log('rain');
// 	let n = 1000;
// 	let c = document.getElementById('rain');
// 	let ctx = c.getContext('2d');
// 	let cw = c.width = c.offsetWidth;
// 	let ch = c.height = 500;
// 	let duration = ch / 850;
// 	let img = new Image();
// 	let particles = [];
// 	let particleNumber = 0;
// 	let Particle = function () {
// 		this.alpha = rand(0.1, 0.4);
// 		this.size = rand(60, 70);
// 		this.draw = function () {

// 			ctx.globalAlpha = this.alpha;
// 			ctx.drawImage(img, this.x, this.y, this.size, this.size);
// 		};
// 	};
// 	function setParticle(p) {

// 		particleNumber++;
// 		let _dur = rand(duration / 2, duration);
// 		let _tl = gsap.timeline()
// 			.fromTo(p, _dur, {
// 				x: rand(-p.size, cw + ch / 2),
// 				y: -p.size,
// 			}, {
// 				x: `-=${rand(ch / 2 - 50, ch / 2)}`,
// 				y: ch + p.size,
// 				// ease: Power0.easeNone,
// 				onComplete() {
// 					setParticle(p);
// 				},
// 			});
// 		if (particleNumber < n) {
// 			_tl.seek(_dur * rand());
// 		}
// 	}
// 	for (let i = 0; i < n; i++) {
// 		particles.push(new Particle());
// 		setParticle(particles[i]);
// 	}
// 	gsap.ticker.add(() => {
// 		ctx.clearRect(0, 0, cw, ch);
// 		for (let i = 0; i < n; i++) {
// 			particles[i].draw();
// 		}
// 	});
// 	window.addEventListener('resize', () => {
// 		particleNumber = 0;
// 		cw = c.width = c.offsetWidth;
// 		ch = c.height = 500;
// 		for (let i = 0; i < n; i++) {
// 			gsap.killTweensOf(particles[i]);
// 			setParticle(particles[i]);
// 		}
// 	});
// 	function rand(min = 0, max = 1) {
// 		return min + (max - min) * Math.random();
// 	}
// 	// img.src = '/images/wheat/step-8-sky.png';
// 	img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAAclBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9wvwjfAAAAJnRSTlMADzQ3BxsfAQIKBBYFX5UsEjxPan6QJ0NJJCkUcXgvhVRZSkCKZM5koNQAAAFNSURBVHgB3ZWFkcRADARvUVozM9uXf4p/GTyMil4BTLnHvdLrN0OJfcHDs8JD7BTgDCq2CKfxHeE0W4zTzBqvJOomhkOCdgTTxEaCJv9HNCxAQzI0pcS/2URo8FqdsQIf4vFanYQkuYDythSgKYYCpxkHK0CjWYDGE658r3DT+i3Bla8cTJOYHtdVVbiuPB749Uz6AaYhdRrCH3A64spfp8IlSXsBSeqO4FqrN04z1pXFN8mqI/h4nouHaaYlhbdruJveojQuXTeGlV9rz6gk134oAkN83ZQBDLGmWToLhrhzTx1YSZQv+zBjITRX+6oDoba29QRWoq4nS32CNTLW2YNWEu49Ww2mWuTfWZuClgTTZO3hoEo4Ptp2KQuoEqubD80EWUJFmmVP5aFK2NVZ25RFBJ6bZj18YHAx3qULTOhWm+GMzzCe8ZmfZ3wBUXcSquSL1HAAAAAASUVORK5CYII=';
// }, 27000);
const initRain = () => {
  console.log('initRain');
  let n = 1000;
  let rain = document.getElementById('rain');
  console.log(rain, 'rain');
	let ctx = rain.getContext('2d');
	let cw = rain.width = rain.offsetWidth;
	let ch = rain.height = 500;
	let duration = ch / 850;
	let img = new Image();
	let particles = [];
	let particleNumber = 0;
	let Particle = function () {
		this.alpha = rand(0.1, 0.4);
		this.size = rand(60, 70);
		this.draw = function () {

			ctx.globalAlpha = this.alpha;
			ctx.drawImage(img, this.x, this.y, this.size, this.size);
		};
	};
	function setParticle(p) {

		particleNumber++;
		let _dur = rand(duration / 2, duration);
		let _tl = gsap.timeline()
			.fromTo(p, _dur, {
				x: rand(-p.size, cw + ch / 2),
				y: -p.size,
			}, {
				x: `-=${rand(ch / 2 - 50, ch / 2)}`,
				y: ch + p.size,
				// ease: Power0.easeNone,
				onComplete() {
					setParticle(p);
				},
			});
		if (particleNumber < n) {
			_tl.seek(_dur * rand());
		}
	}
	for (let i = 0; i < n; i++) {
		particles.push(new Particle());
		setParticle(particles[i]);
	}
	gsap.ticker.add(() => {
		ctx.clearRect(0, 0, cw, ch);
		for (let i = 0; i < n; i++) {
			particles[i].draw();
		}
	});
	window.addEventListener('resize', () => {
		particleNumber = 0;
		cw = c.width = c.offsetWidth;
		ch = c.height = 500;
		for (let i = 0; i < n; i++) {
			gsap.killTweensOf(particles[i]);
			setParticle(particles[i]);
		}
	});
	function rand(min = 0, max = 1) {
		return min + (max - min) * Math.random();
	}
	// img.src = '/images/wheat/step-8-sky.png';
	img.src = 'data:image/png;base64,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';
};

export {initRain};

